import React from 'react';

import { STEPS } from '../constants';
import CollapsibleSection from './CollapsibleSection/CollapsibleSection';
import GeneralStep from './Steps/GeneralStep';
import PersonalStep from './Steps/PersonalStep';

import moment from 'moment';

export default class AppointmentForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            shouldDisableAppt: props.shouldDisableAppt
        };
    }
    render(props) {
        let viewData = this.props.data;
        let ApplyBtn = this.getApplyBtn.bind(this);
        let shouldDisable = this.props.shouldDisableAppt || this.state.shouldDisableAppt;
        let generalTitleClass = this.props.currentStep === STEPS.PERSONAL_DETAILS ? 'pointer' : '';
        
        return (<div className="form-wrapper">
            <CollapsibleSection
                title="General Details"
                isExpanded={this.props.currentStep === STEPS.GENERAL_DETAILS}
                onTitleClick={this.props.onGeneralTitleClick}
                titleClass={generalTitleClass}
            >
                
                <GeneralStep
                    centers={viewData.centers}
                    scheduleTimes={viewData.scheduleTimes}
                    serviceTypes={viewData.serviceTypes}
                    cars={viewData.cars}
                    apptSettings={viewData.centersApptSettings}
                    date={this.props.scheduleDate || moment().utcOffset(0, true)}
                    setAppointmentState={this.props.setAppointmentState}
                    appointment={this.props.appointment}
                    errors={this.props.generalErrors}
                />
            </CollapsibleSection>

            {!this.isDisabled() && <CollapsibleSection
                title="Personal Details"
                isExpanded={this.props.currentStep === STEPS.PERSONAL_DETAILS}>

                <PersonalStep
                    setAppointmentState={this.props.setAppointmentState}
                    errors={this.props.personalErrors}
                />
            </CollapsibleSection>}

            {!this.isDisabled() && <ApplyBtn />}
        </div>);
    }
    isDisabled() { 
        let centerId = this.props.appointment.center;
        if(!centerId || !this.props.data) { 
            return false;
        }
        // apptSettings
        let shouldDisableAppt = false;
        let relevantSettings = this.props.data.centersApptSettings.filter(function (item) {
            return item.id == centerId;
        });
        if (relevantSettings.length > 0) {
            shouldDisableAppt = relevantSettings[0].appointmentMode == 1 || relevantSettings[0].appointmentMode == 2;
        }

        return shouldDisableAppt;
    }
    getApplyBtn() {
        let text = null;

        switch (this.props.currentStep) {
            case STEPS.GENERAL_DETAILS:
                text = 'Next';
                break;
            case STEPS.PERSONAL_DETAILS:
                text = 'Submit Request';
                break;
            default:
                throw new Error('Invalid step');

        }

        return (<button
            className="apply-btn btn"
            onClick={() => this.props.moveNext()}>
                {text}
            </button>);
    }
}


// WEBPACK FOOTER //
// ./Src/Shared/AppointmentScheduler/AppointmentForm/AppointmentForm.jsx